import {
  FOLDER_WORKSPACE_ACCESS,
} from "@/lib/folder/constants";
import z from "@/lib/zod";
import { FolderTypeEnumValue, FolderUserRoleEnumValue, FolderAccessLevelEnumValue } from "@panda0/panda0-graphql/defs";
import { booleanQuerySchema, getPaginationQuerySchema } from "./misc";

const workspaceFolderAccess = z
  .enum(
    Object.keys(FOLDER_WORKSPACE_ACCESS) as [
      FolderAccessLevelEnumValue,
      ...FolderAccessLevelEnumValue[],
    ],
  )
  .nullish()
  .default(null)
  .describe("The access level of the folder within the workspace.");

export const folderUserRoleSchema = z.custom<FolderUserRoleEnumValue>()
  .describe("The role of the user in the folder.");

export const FolderSchema = z.object({
  id: z.string().describe("The unique ID of the folder."),
  name: z.string().describe("The name of the folder."),
  type: z.custom<FolderTypeEnumValue>(),
  accessLevel: workspaceFolderAccess,
  jobCount: z
    .number()
    .describe("The number of links in the folder.")
    .default(0),
  createdAt: z.preprocess(
    (val) => (val && val instanceof Date ? val.toISOString() : val),
    z.string().datetime({ offset: true })
  ).pipe(z.coerce.date()).describe("The date the folder was created."),
  updatedAt: z.preprocess(
    (val) => (val && val instanceof Date ? val.toISOString() : val),
    z.string().datetime({ offset: true })
  ).pipe(z.coerce.date()).describe("The date the folder was updated."),
});

export const createFolderSchema = z.object({
  name: z.string().describe("The name of the folder.").max(190),
  accessLevel: workspaceFolderAccess,
});

export const FOLDERS_MAX_PAGE_SIZE = 50;

export const listFoldersQuerySchema = z
  .object({
    search: z
      .string()
      .optional()
      .describe("The search term to filter the folders by."),
    includeJobsCount: booleanQuerySchema
      .optional()
      .describe("Whether to include the job count in the response."),
  })
  .merge(getPaginationQuerySchema({ pageSize: FOLDERS_MAX_PAGE_SIZE }));

export const updateFolderSchema = createFolderSchema.partial();
